import { render, staticRenderFns } from "./daiban.vue?vue&type=template&id=29e4a658&scoped=true"
import script from "./daiban.vue?vue&type=script&lang=js"
export * from "./daiban.vue?vue&type=script&lang=js"
import style0 from "./daiban.vue?vue&type=style&index=0&id=29e4a658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e4a658",
  null
  
)

export default component.exports